/**
 * Template names stay unique per kind among the templates a user can see: a
 * name already taken is saved with " (1)", " (2)", … at the end instead of
 * being refused.
 *
 * Mirrored in spt/src/helpers/template-names.ts, fixture for fixture — the
 * editor shows the name it will be saved as, and the save endpoint applies the
 * same rule so a stale client cannot store a duplicate. Change both together.
 *
 * Comparison is trimmed and case-insensitive ("Grocery" and " grocery " are the
 * same name). A name that already ends in "(n)" counts up from its base, so
 * saving "Grocery (1)" next to "Grocery" and "Grocery (1)" gives "Grocery (2)",
 * never "Grocery (1) (1)".
 */
const norm = (name) => String(name == null ? '' : name).trim().toLowerCase();

const SUFFIX = /\s*\((\d+)\)$/;

export function uniqueTemplateName(name, takenNames = []) {
  const wanted = String(name == null ? '' : name).trim();
  const taken = new Set(takenNames.map(norm));
  if (!taken.has(wanted.toLowerCase())) return wanted;
  const base = wanted.replace(SUFFIX, '').trim() || wanted;
  for (let n = 1; ; n++) {
    const candidate = `${base} (${n})`;
    if (!taken.has(candidate.toLowerCase())) return candidate;
  }
}

/** Names the template being edited must not take: the same kind, minus itself. */
export function takenNamesFor(templates, kind, selfId) {
  return (templates || [])
    .filter((t) => (t.type === 'group' ? 'group' : 'subitem') === kind && (selfId == null || String(t.id) !== String(selfId)))
    .map((t) => t.name);
}
